import { Routes } from '@app/constants/routes';

import { MyRouteObject } from '@app/models/router';
import { QRCodeModule } from './QRCodeModule';
import { ScanQRCodePage } from './pages/ScanQRCodePage';

import { useEffect } from 'react';
import { useTypedNavigate, useTypedParams } from '@app/router';

export const RedirectQR: React.FC = () => {
  const navigate = useTypedNavigate();
  const { id } = useTypedParams(Routes.qr_code.root_scanned);

  useEffect(() => {
    if (id) {
      navigate({ to: `/qr/${id}`, replace: true });
    }
  }, [id, navigate]);

  return null;
};

export const QRCodeRoutes: MyRouteObject = {
  path: Routes.index,
  element: <QRCodeModule />,
  children: [
    { path: Routes.qr_code.scanned, element: <ScanQRCodePage /> },
    { path: Routes.qr_code.old_scanned, element: <ScanQRCodePage /> },
    { path: Routes.qr_code.root_scanned, element: <RedirectQR /> },
  ],
};
